module.exports = __webpack_public_path__ + "static/media/sundropbanner.06d264d3.png";